"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const log_answers_1 = require("../log-answers");
const metrika_1 = require("../metrika");
const lang_1 = require("../lang");
const init_1 = require("../init");
const redirects_1 = require("../redirects");
const logic_1 = require("../logic");
const transition_1 = require("../transition");
const transition_timer_1 = require("../transition-timer");
const iframe_1 = require("../iframe");
const root_text_fit_1 = require("../root-text-fit");
const cookie_1 = require("../cookie");
const ensureInterviewId_1 = require("../ensureInterviewId");
const api_1 = require("../api");
function* rootSaga({ store }) {
    yield (0, effects_1.all)([
        (0, lang_1.router)(),
        (0, init_1.router)(),
        (0, metrika_1.router)(),
        (0, log_answers_1.router)(),
        (0, redirects_1.router)(),
        (0, logic_1.router)(store),
        (0, transition_1.router)(),
        (0, transition_timer_1.router)(),
        (0, iframe_1.router)(),
        (0, root_text_fit_1.router)(),
        (0, cookie_1.router)(),
        (0, ensureInterviewId_1.router)(),
        (0, api_1.watchRequests)()
    ]);
}
exports.default = rootSaga;
